import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Lock, X, FloppyDisk } from "@phosphor-icons/react";

export default function ChangePasswordModal({ onClose }) {
    const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
    const [saving, setSaving] = useState(false);

    const submit = async () => {
        if (f.new_password.length < 6) { toast.error("New password must be at least 6 characters"); return; }
        if (f.new_password !== f.confirm) { toast.error("New passwords don't match"); return; }
        try {
            setSaving(true);
            await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
            toast.success("Password updated");
            onClose && onClose();
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[95] bg-slate-900/80 flex items-start sm:items-center justify-center p-3 overflow-y-auto" data-testid="change-password-modal">
            <div className="bg-white rounded-lg w-full max-w-md shadow-xl border border-slate-200 relative">
                <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center" data-testid="change-password-close"><X size={16} /></button>
                <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
                    <Lock size={18} weight="duotone" className="text-[var(--grindrod-red)]" />
                    <div>
                        <div className="uppercase-label text-[10px] text-[var(--grindrod-red)]">Account</div>
                        <h3 className="font-display font-black text-lg text-[var(--grindrod-navy)]">Change password</h3>
                    </div>
                </div>
                <div className="p-5 space-y-3">
                    <Field label="Current password">
                        <input type="password" autoFocus value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className="g-input" data-testid="cp-current" autoComplete="current-password" />
                    </Field>
                    <Field label="New password (min 6 characters)">
                        <input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className="g-input" data-testid="cp-new" autoComplete="new-password" />
                    </Field>
                    <Field label="Confirm new password">
                        <input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="g-input" data-testid="cp-confirm" autoComplete="new-password" />
                    </Field>
                </div>
                <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2">
                    <button onClick={onClose} className="text-sm px-3 py-2 rounded-sm bg-slate-100 hover:bg-slate-200">Cancel</button>
                    <button onClick={submit} disabled={saving} className="text-sm px-3 py-2 rounded-sm bg-[var(--grindrod-navy)] text-white inline-flex items-center gap-2 disabled:opacity-60" data-testid="cp-save">
                        <FloppyDisk size={14} weight="bold" /> {saving ? "Saving…" : "Update password"}
                    </button>
                </div>
            </div>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-slate-500 font-bold block mb-1">{label}</span>
            {children}
        </label>
    );
}
